export default __webpack_public_path__ + "static/media/hslUnknown.b4caf4e3.svg";